<nz-table
  #tableRef
  nzShowSizeChanger
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  nzSize="small"
  >
  <thead>
    <tr>
      <th nzColumnKey="articleName" [nzSortFn]="true">Artikelname</th>
      <th nzColumnKey="orderNumber" [nzSortFn]="true" nzWidth="140px">Bestellnummer</th>
      <th nzColumnKey="ean" [nzSortFn]="true" nzWidth="140px">EAN</th>
      <th nzColumnKey="inStock" [nzSortFn]="true">Bestand</th>
      <th nzWidth="70px"></th>
    </tr>
  </thead>
  <tbody>
    @for (item of tableRef.data; track item) {
      <tr>
        <td>{{ item.articleName }} @if (item.variantName) {
          / {{ item.variantName }}
        }</td>
        <td>{{ item.orderNumber }}</td>
        <td>{{ item.ean }}</td>
        <td>{{ item.inStock }}</td>
        <td nzRight>
          <div class="actions">
            <app-add-edit-article-modal #modal>
              <span trigger>
                <app-icon-button
                  icon="edit"
                  [ariaLabel]="'Artikel bearbeiten: ' + item.articleName"
                  (pressed)="modal.showModal($any({ id: item.articleId, name: item.articleName }))"
                ></app-icon-button>
              </span>
            </app-add-edit-article-modal>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

